import React, { useEffect, useState } from "react";
import {
  Typography,
  Checkbox,
  Button,
  FormControlLabel,
  Container,
  Grid,
  Box,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ShieldIcon from "../../assets/shield.svg";
import detailIcon from "../../assets/consent_details.svg";
import imageIcon from "../../assets/consent_image.svg";
import voiceIcon from "../../assets/consent_voice.svg";
import videoICon from "../../assets/consent_video.svg";

const ConsentComponent = ({ handleConsent, consentInfo }) => {
  const [isChecked, setIsChecked] = useState(false);
  const [isChecked2, setIsChecked2] = useState(false);

  const handleCheckboxChange = (event) => {
    setIsChecked(event.target.checked);
  };

  const handleCheckboxChange2 = (event) => {
    setIsChecked2(event.target.checked);
  };

  useEffect(() => {
    if (consentInfo) {
      setIsChecked(
        !consentInfo?.checkbox && !consentInfo?.individual_consent_checkbox
      );
      setIsChecked2(!consentInfo?.data_collector_consent_checkbox);
    }
  }, [consentInfo]);

  return (
    <Container
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        mt: 3,
      }}
    >
      {consentInfo?.new_consent ? (
        <>
          <img
            src={ShieldIcon}
            alt="Shield Icon"
            style={{ marginBottom: 20 }}
          />
          <Typography
            variant="h4"
            sx={{
              mb: 2,
              color: "#263238",
              lineHeight: "150%",
              letterSpacing: "0.15px",
              textTransform: "capitalize",
              fontWeight: 300,
              fontSize: { xs: "24px", md: "32px" },
            }}
          >
            We Value Your Consent
          </Typography>

          {/* Gray line */}
          <Box sx={{ width: "100%", borderBottom: "1px solid #ccc", my: 2 }} />
          {consentInfo?.para1 && (
            <Typography
              variant="body1"
              paragraph={true}
              align="justify"
              sx={{
                color: "var(--text-color, #202124)",
                lineHeight: "normal",
                letterSpacing: "0.15px",
                fontWeight: 400,
                fontSize: { xs: "14px", md: "16px" },
                my: 2,
              }}
            >
              {consentInfo?.para1}
            </Typography>
          )}

          {consentInfo?.points && (
            <Box sx={{ textAlign: "left", width: "100%" }}>
              <Typography
                variant="body1"
                align="justify"
                sx={{
                  color: "var(--text-color, #202124)",
                  lineHeight: "normal",
                  letterSpacing: "0.15px",
                  fontWeight: 400,
                  fontSize: { xs: "14px", md: "16px" },
                }}
              >
                By agreeing to participate, you acknowledge and understand the
                following objectives of our data collection:
              </Typography>
              {consentInfo.points.map((point, index) => (
                <Typography
                  variant="body1"
                  align="justify"
                  sx={{
                    color: "var(--text-color, #202124)",
                    lineHeight: "normal",
                    letterSpacing: "0.15px",
                    fontWeight: 400,
                    fontSize: { xs: "14px", md: "16px" },
                  }}
                >
                  {index + 1}. {point}
                </Typography>
              ))}
            </Box>
          )}
          {consentInfo?.para2 && (
            <Typography
              variant="body1"
              align="justify"
              sx={{
                color: "var(--text-color, #202124)",
                lineHeight: "normal",
                letterSpacing: "0.15px",
                fontWeight: 400,
                fontSize: { xs: "14px", md: "16px" },
                my: 2,
              }}
            >
              {consentInfo?.para2}
            </Typography>
          )}
          <Box sx={{ width: "100%", borderBottom: "1px solid #ccc", my: 2 }} />
          <Typography
            variant="h6"
            sx={{
              color: "#0226A4",
              lineHeight: "200%",
              letterSpacing: "0.15px",
              textTransform: "capitalize",
              fontWeight: 600,
              fontSize: { xs: "20px", md: "24px" },
            }}
          >
            User Consent Form
          </Typography>
          {consentInfo?.sections && (
            <Box sx={{ textAlign: "left", width: "100%" }}>
              {consentInfo.sections.map((section, index) => (
                <>
                  <Box
                    component="span"
                    sx={{
                      color: "var(--text-color, #202124)",
                      fontSize: { xs: "16px", md: "18px" },
                      fontWeight: 500,
                      my: 2,
                    }}
                  >
                    Section {index + 1}: {section.title}
                  </Box>
                  <Typography
                    variant="body1"
                    align="justify"
                    sx={{
                      color: "var(--text-color, #202124)",
                      lineHeight: "normal",
                      letterSpacing: "0.15px",
                      fontWeight: 400,
                      fontSize: { xs: "14px", md: "16px" },
                      mb: 2,
                    }}
                  >
                    {section.body}
                  </Typography>
                </>
              ))}
            </Box>
          )}
          <Box sx={{ width: "100%", borderBottom: "1px solid #ccc", my: 2 }} />
          {(consentInfo?.checkbox ||
            consentInfo?.individual_consent_checkbox) && (
            <Grid item xs={12}>
              <Grid
                item
                xs={12}
                sx={{ display: "flex", alignItems: "center", mb: 1 }}
              >
                <Checkbox
                  checked={isChecked}
                  onChange={handleCheckboxChange}
                  sx={{ margin: 0 }}
                />
                <Typography
                  variant="body1"
                  align="justify"
                  sx={{
                    fontSize: { xs: "12px", md: "16px" },
                    color: "#404040",
                    fontFeatureSettings: "'clig' off, 'liga' off",
                    fontStyle: "normal",
                    fontWeight: 400,
                    lineHeight: "normal",
                    letterSpacing: "0.2px",
                  }}
                >
                  {consentInfo?.checkbox ? (
                    <div>{consentInfo?.checkbox}</div>
                  ) : (
                    <div>{consentInfo?.individual_consent_checkbox}</div>
                  )}
                </Typography>
              </Grid>
            </Grid>
          )}
          <Grid item xs={12} sx={{ width: "100%" }}>
            <Button
              variant="contained"
              color="primary"
              sx={{ my: 2, width: "100%" }} // Full width button
              onClick={handleConsent}
              disabled={!isChecked || !isChecked2}
              endIcon={<CheckCircleIcon />} // Right arrow icon
              style={{ fontSize: { xs: "14px", md: "16px" } }}
            >
              Submit Consent
            </Button>
          </Grid>
        </>
      ) : (
        <>
          <img
            src={ShieldIcon}
            alt="Shield Icon"
            style={{ marginBottom: 20 }}
          />
          <Typography
            variant="h4"
            sx={{
              mb: 2,
              color: "#263238",
              lineHeight: "150%",
              letterSpacing: "0.15px",
              textTransform: "capitalize",
              fontWeight: 300,
              fontSize: { xs: "24px", md: "32px" },
            }}
          >
            We Value Your Consent
          </Typography>

          {/* Gray line */}
          <Box sx={{ width: "100%", borderBottom: "1px solid #ccc", my: 2 }} />

          <Grid container>
            <Grid item xs={12}>
              <Typography
                variant="h6"
                sx={{
                  mb: 2,
                  color: "#0226A4",
                  lineHeight: "200%",
                  letterSpacing: "0.15px",
                  textTransform: "capitalize",
                  fontWeight: 600,
                  fontSize: { xs: "20px", md: "24px" },
                }}
              >
                What Do We Collect?
              </Typography>
            </Grid>
            {consentInfo?.details && (
              <Grid item xs={12}>
                <Grid
                  item
                  xs={12}
                  sx={{ display: "flex", alignItems: "center", mb: 1 }}
                >
                  <img
                    src={detailIcon}
                    alt="Shield Icon"
                    style={{
                      width: 25,
                      height: 25,
                      marginRight: 10,
                      verticalAlign: "middle",
                    }}
                  />
                  <Box
                    component="span"
                    sx={{
                      color: "var(--text-color, #202124)",
                      fontSize: { xs: "16px", md: "18px" },
                      fontWeight: 500,
                      mr: 1,
                    }}
                  >
                    Your Details
                  </Box>
                </Grid>
                <Grid item xs={12} sx={{ ml: 4.5, mb: 2 }}>
                  <Typography
                    variant="body1"
                    sx={{
                      color: "var(--text-color, #202124)",
                      lineHeight: "normal",
                      letterSpacing: "0.15px",
                      fontWeight: 400,
                      fontSize: { xs: "14px", md: "16px" },
                    }}
                  >
                    {consentInfo?.details}
                  </Typography>
                </Grid>
              </Grid>
            )}
            {consentInfo?.voice && (
              <Grid item xs={12}>
                <Grid
                  item
                  xs={12}
                  sx={{ display: "flex", alignItems: "center", mb: 1 }}
                >
                  <img
                    src={voiceIcon}
                    alt="Shield Icon"
                    style={{
                      width: 25,
                      height: 25,
                      marginRight: 10,
                      verticalAlign: "middle",
                    }}
                  />
                  <Box
                    component="span"
                    sx={{
                      color: "var(--text-color, #202124)",
                      fontSize: { xs: "16px", md: "18px" },
                      mr: 1,
                      fontWeight: 500,
                    }}
                  >
                    Your Voice
                  </Box>
                </Grid>
                <Grid item xs={12} sx={{ ml: 4.5, mb: 2 }}>
                  <Typography
                    variant="body1"
                    sx={{
                      color: "var(--text-color, #202124)",
                      lineHeight: "normal",
                      letterSpacing: "0.15px",
                      fontWeight: 400,
                      fontSize: { xs: "14px", md: "16px" },
                    }}
                  >
                    {consentInfo?.voice}
                  </Typography>
                </Grid>
              </Grid>
            )}
            {consentInfo?.video && (
              <Grid item xs={12}>
                <Grid
                  item
                  xs={12}
                  sx={{ display: "flex", alignItems: "center", mb: 1 }}
                >
                  <img
                    src={videoICon}
                    alt="Shield Icon"
                    style={{
                      width: 25,
                      height: 25,
                      marginRight: 10,
                      verticalAlign: "middle",
                    }}
                  />
                  <Box
                    component="span"
                    sx={{
                      color: "var(--text-color, #202124)",
                      fontSize: { xs: "16px", md: "18px" },
                      mr: 1,
                      fontWeight: 500,
                    }}
                  >
                    Your Video
                  </Box>
                </Grid>
                <Grid item xs={12} sx={{ ml: 4.5, mb: 2 }}>
                  <Typography
                    variant="body1"
                    sx={{
                      color: "var(--text-color, #202124)",
                      lineHeight: "normal",
                      letterSpacing: "0.15px",
                      fontWeight: 400,
                      fontSize: { xs: "14px", md: "16px" },
                    }}
                  >
                    {consentInfo?.video}
                  </Typography>
                </Grid>
              </Grid>
            )}
            {consentInfo?.image && (
              <Grid item xs={12}>
                <Grid
                  item
                  xs={12}
                  sx={{ display: "flex", alignItems: "center", mb: 1 }}
                >
                  <img
                    src={imageIcon}
                    alt="Shield Icon"
                    style={{
                      width: 25,
                      height: 25,
                      marginRight: 10,
                      verticalAlign: "middle",
                    }}
                  />
                  <Box
                    component="span"
                    sx={{
                      color: "var(--text-color, #202124)",
                      fontSize: { xs: "16px", md: "18px" },
                      mr: 1,
                      fontWeight: 500,
                    }}
                  >
                    Your Image
                  </Box>
                </Grid>
                <Grid item xs={12} sx={{ ml: 4.5, mb: 2 }}>
                  <Typography
                    variant="body1"
                    sx={{
                      color: "var(--text-color, #202124)",
                      lineHeight: "normal",
                      letterSpacing: "0.15px",
                      fontWeight: 400,
                      fontSize: { xs: "14px", md: "16px" },
                    }}
                  >
                    {consentInfo?.image}
                  </Typography>
                </Grid>
              </Grid>
            )}

            {/* Gray line */}
            <Box
              sx={{ width: "100%", borderBottom: "1px solid #ccc", my: 2 }}
            />

            <Grid item xs={12}>
              <Typography
                variant="h6"
                sx={{
                  mb: 2,
                  color: "#0226A4",
                  lineHeight: "200%",
                  letterSpacing: "0.15px",
                  textTransform: "capitalize",
                  fontWeight: 600,
                  fontSize: { xs: "20px", md: "24px" },
                }}
              >
                How Do We Use Your Data?
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  color: "var(--text-color, #202124)",
                  lineHeight: "normal",
                  letterSpacing: "0.15px",
                  fontWeight: 400,
                  mb: 2,
                  fontSize: { xs: "14px", md: "16px" },
                }}
              >
                {consentInfo?.usage ? (
                  <div>{consentInfo?.usage}</div>
                ) : (
                  <div>default setting</div>
                )}
              </Typography>
            </Grid>
            <Box
              sx={{ width: "100%", borderBottom: "1px solid #ccc", my: 2 }}
            />
            <Grid item xs={12}>
              <Typography
                variant="h6"
                sx={{
                  mb: 2,
                  color: "#0226A4",
                  lineHeight: "200%",
                  letterSpacing: "0.15px",
                  textTransform: "capitalize",
                  fontWeight: 600,
                  fontSize: { xs: "20px", md: "24px" },
                }}
              >
                How Do We Safely Store Your Data?
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  color: "var(--text-color, #202124)",
                  lineHeight: "normal",
                  letterSpacing: "0.15px",
                  fontWeight: 400,
                  mb: 2,
                  fontSize: { xs: "14px", md: "16px" },
                }}
              >
                {consentInfo?.storage ? (
                  <div>{consentInfo?.storage}</div>
                ) : (
                  <div>default setting</div>
                )}
              </Typography>
            </Grid>
            <Box
              sx={{ width: "100%", borderBottom: "1px solid #ccc", my: 2 }}
            />
            <Typography
              variant="h6"
              sx={{
                mb: 2,
                color: "#0226A4",
                lineHeight: "200%",
                letterSpacing: "0.15px",
                textTransform: "capitalize",
                fontWeight: 600,
                fontSize: { xs: "20px", md: "24px" },
              }}
            >
              Establishment of consent
            </Typography>
            {(consentInfo?.checkbox ||
              consentInfo?.individual_consent_checkbox) && (
              <Grid item xs={12}>
                <Grid
                  item
                  xs={12}
                  sx={{ display: "flex", alignItems: "center", mb: 1 }}
                >
                  <Checkbox
                    checked={isChecked}
                    onChange={handleCheckboxChange}
                    sx={{ margin: 0 }}
                  />

                  <Box
                    component="span"
                    sx={{
                      color: "var(--text-color, #202124)",
                      fontSize: { xs: "16px", md: "18px" },
                      mr: 1,
                      fontWeight: 500,
                    }}
                  >
                    Individual Side:
                  </Box>
                </Grid>
                <Grid item xs={12} sx={{ ml: 4.5, mb: 2 }}>
                  <Typography
                    variant="body1"
                    sx={{
                      fontSize: { xs: "12px", md: "16px" },
                      color: "#404040",
                      fontFeatureSettings: "'clig' off, 'liga' off",
                      fontStyle: "normal",
                      fontWeight: 400,
                      lineHeight: "normal",
                      letterSpacing: "0.2px",
                    }}
                  >
                    {consentInfo?.checkbox ? (
                      <div>{consentInfo?.checkbox}</div>
                    ) : (
                      <div>{consentInfo?.individual_consent_checkbox}</div>
                    )}
                  </Typography>
                </Grid>
              </Grid>
            )}
            {consentInfo?.data_collector_consent_checkbox && (
              <Grid item xs={12}>
                <Grid
                  item
                  xs={12}
                  sx={{ display: "flex", alignItems: "center", mb: 1 }}
                >
                  <Checkbox
                    checked={isChecked2}
                    onChange={handleCheckboxChange2}
                    sx={{ margin: 0 }}
                  />

                  <Box
                    component="span"
                    sx={{
                      color: "var(--text-color, #202124)",
                      fontSize: { xs: "16px", md: "18px" },
                      mr: 1,
                      fontWeight: 500,
                    }}
                  >
                    Data Collector:
                  </Box>
                </Grid>
                <Grid item xs={12} sx={{ ml: 2.5, mb: 2 }}>
                  <Typography
                    variant="body1"
                    sx={{
                      fontSize: { xs: "12px", md: "16px" },
                      color: "#404040",
                      fontFeatureSettings: "'clig' off, 'liga' off",
                      fontStyle: "normal",
                      fontWeight: 400,
                      lineHeight: "normal",
                      letterSpacing: "0.2px",
                      marginLeft: "1rem",
                    }}
                  >
                    {consentInfo?.data_collector_consent_checkbox ? (
                      <div>{consentInfo?.data_collector_consent_checkbox}</div>
                    ) : (
                      <div>default setting for checkbox2</div>
                    )}
                  </Typography>
                </Grid>
              </Grid>
            )}
            <Grid item xs={12}>
              <Button
                variant="contained"
                color="primary"
                sx={{ my: 2, width: "100%" }} // Full width button
                onClick={handleConsent}
                disabled={!isChecked || !isChecked2}
                endIcon={<CheckCircleIcon />} // Right arrow icon
                style={{ fontSize: { xs: "14px", md: "16px" } }}
              >
                Submit Consent
              </Button>
            </Grid>
          </Grid>
        </>
      )}
    </Container>
  );
};

export default ConsentComponent;
